export default "__VITE_ASSET__jK4BmFUc__"